import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientAPI } from "./axiosAnstance"; // Vérifiez l'orthographe 'axiosInstance' si possible

/**
 * ACTIONS ASYNC (THUNKS)
 */

// 1. Récupérer tous les paramètres
export const listPrestationsAPI = createAsyncThunk(
  "prestation/list",
  async (_, thunkAPI) => {
    try {
      const response = await clientAPI.get("/api/prestations-params");
      console.log('la liste pres ::: ',response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur de chargement");
    }
  }
);

// 2. Récupérer uniquement les prestations actives
export const listPrestationsActiveAPI = createAsyncThunk(
  "prestation/listActive",
  async (_, thunkAPI) => {
    try {
      const response = await clientAPI.get("/api/prestations-params/active");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur de chargement des actifs");
    }
  }
);

// 3. Sauvegarder ou Modifier (Create / Update)
export const savePrestationAPI = createAsyncThunk(
  "prestation/save",
  async (data, thunkAPI) => {
    try {
      let response;
      if (data.id) {
        // Mode Update
        response = await clientAPI.put(`/api/prestations-params/${data.id}`, data);
      } else {
        // Mode Create
        response = await clientAPI.post("/api/prestations-params", data);
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur lors de l'enregistrement");
    }
  }
);

// 4. Supprimer une prestation
export const deletePrestationAPI = createAsyncThunk(
  "prestation/delete",
  async (id, thunkAPI) => {
    try {
      // Si votre API Java possède un @DeleteMapping("/{id}")
      const response = await clientAPI.delete(`/api/v1/prestations-params/${id}`);
      return id; // On retourne l'id pour le filtrer dans le state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur de suppression");
    }
  }
);

export const listPrestationTabsAPI = createAsyncThunk(
  "prestation/listTabs",
  async () => {
    const response = await clientAPI.get("/api/prestations-params/prestation_tab"); // Créez ce endpoint
    console.log('la liste pres ::: ',response.data);
    return response.data;
  }
);

// Nouvelle action pour récupérer les périodes (params) d'une prestation
export const listParamsByPrestationAPI = createAsyncThunk(
  "prestation/listParamsByPrestation",
  async (idPrestation, thunkAPI) => {
    try {
      // Attention à bien mettre le chemin défini dans le controller
      const response = await clientAPI.get(`/api/prestations-params/by-prestation/${idPrestation}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur lors du chargement des paramètres");
    }
  }
);
/**
 * SLICE DEFINITION
 */
const PrestationSlice = createSlice({
  name: "prestation",
  initialState: {
    liste: [], // Liste complète pour le tableau
    listeTabs:[],
    listeParamsFiltrer: [],
    listeActive: [],     // Liste filtrée pour les formulaires clients
    status: 'idle',      // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    saving: false        // Pour gérer l'état de chargement des boutons "Confirmer"
  },
  reducers: {
    // Reducer pour réinitialiser les erreurs si besoin
    clearPrestationError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(listPrestationTabsAPI.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(listPrestationTabsAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeTabs = action.payload;
      })
      .addCase(listPrestationTabsAPI.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      /* List Full */
      .addCase(listPrestationsAPI.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(listPrestationsAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.liste = action.payload;
      })
      .addCase(listPrestationsAPI.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(listParamsByPrestationAPI.fulfilled, (state, action) => {
        state.listeParamsFiltrer = action.payload;
      })

      /* List Active */
      .addCase(listPrestationsActiveAPI.fulfilled, (state, action) => {
        state.listeActive = action.payload;
      })

      /* Save / Update */
      .addCase(savePrestationAPI.pending, (state) => {
        state.saving = true;
      })
      .addCase(savePrestationAPI.fulfilled, (state) => {
        state.saving = false;
        state.status = 'idle'; // Provoquera un refresh si utilisé dans un useEffect
      })
      .addCase(savePrestationAPI.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      /* Delete */
      .addCase(deletePrestationAPI.fulfilled, (state, action) => {
        // Optimisation : supprimer l'élément du state sans refaire un appel API complet
        state.liste = state.liste.filter(item => item.id !== action.payload);
      });
  },
});

export const { clearPrestationError } = PrestationSlice.actions;

export default PrestationSlice.reducer;
